<template>
	<div class="auth-page">
		<div class="auth-card">
			<div class="auth-badge"><i class="fas fa-key"></i></div>
			<h1 class="auth-title">Mot de passe oublié</h1>
			<p class="auth-subtitle">Indiquez votre identifiant, un email de réinitialisation vous sera envoyé</p>

			<b-form class="auth-form" @submit="onSubmit">
				<div class="auth-field">
					<label for="username">Votre identifiant</label>
					<b-form-input
						id="username"
						class="auth-input"
						type="text"
						v-model="username"
						required
						autofocus
						placeholder="Identifiant"></b-form-input>
				</div>
				<b-button type="submit" class="auth-submit" variant="primary">Valider</b-button>
			</b-form>

			<b-alert class="auth-alert" v-if="error" show variant="danger">{{ errorMsg }}</b-alert>

			<div class="auth-links">
				<a href="/login">Retour à la connexion</a>
			</div>
		</div>
	</div>
</template>

<script>
	import password from "../services/password.js";

	export default {
		name: "password_reset",
		data() {
			return {
				username: "",
				error: false,
				errorMsg: null,
			};
		},
		methods: {
			onSubmit(evt) {
				evt.preventDefault();
				this.error = false;
				password
					.password_reset(this.username)
					.then((res) => {
						let email = res.data.email;
						this.$notify({
							group: "info",
							title: "Email envoyé",
							text: email
								? "Un email de réinitialisation a été envoyé à " + email
								: "Un email de réinitialisation vous a été envoyé.",
							type: "success",
						});
						this.$router.push({ name: "login" });
					})
					.catch((err) => {
						this.error = true;
						this.errorMsg =
							(err.response && err.response.data && err.response.data.msg) ||
							"Une erreur est survenue, veuillez réessayer.";
						this.$notify({
							group: "info",
							title: "Erreur",
							text: this.errorMsg,
							type: "error",
						});
					});
			},
		},
	};
</script>

<style></style>
